module.exports = __webpack_public_path__ + "img/header-engagementRingsGold.6465f9e.webp";